import { LocalPath } from './LocalPath'
import { Locale, localesPaths } from './Locale'
import { useLocale } from './LocaleContext'
import { useMemo } from 'react'

export function useLocalePath(to: LocalPath | string, locale?: Locale) {
  const currentLocale = useLocale()

  return useMemo(
    () => (localesPaths.get(locale || currentLocale) + to).replace('//', '/'),
    [to, locale, currentLocale],
  )
}
